
import React, { useState, useEffect } from 'react';

const CustomAd = ({ ads, interval = 5000 }) => {
  const [indice, setIndice] = useState(0);

  useEffect(() => {
    setIndice(0);

    if (!ads || ads.length <= 1) return undefined;

    const temporizador = setInterval(() => {
      setIndice((previo) => (previo + 1) % ads.length);
    }, interval);

    return () => clearInterval(temporizador);
  }, [ads, interval]);

  if (!ads || ads.length === 0) return null;

  const anuncio = ads[indice % ads.length];

  if (!anuncio || !anuncio.image_url) return null;

  return (
    <div className="ed-anuncio">
      {anuncio.enlace?.trim() ? (
        <a
          href={anuncio.enlace.trim()}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={anuncio.image_url}
            alt={anuncio.empresa || 'Publicidad'}
            className="ed-anuncio__imagen"
            loading="lazy"
            decoding="async"
          />
        </a>
      ) : (
        <img
          src={anuncio.image_url}
          alt={anuncio.empresa || 'Publicidad'}
          className="ed-anuncio__imagen"
          loading="lazy"
          decoding="async"
        />
      )}
    </div>
  );
};

export default CustomAd;
